/** 
 *  ==========================
 *  BLOCK: Hero Block Edit
 *  ==========================
 */

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { applyFilters, addFilter } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'
import { Fragment } from '@wordpress/element'
import { PanelBody, ToggleControl, SelectControl } from '@wordpress/components'
import { 
	RichText, InnerBlocks
} from '@wordpress/block-editor'

/**
 * Internal dependencies
 */
import { name } from './index'
import { withTabbedInspector } from '~cartzillagb/higher-order'
import ImageDesignBasic from './images/basic.png'
import ImageDesignPlain from './images/plain.png'

/**
 * External dependencies
 */
 import {
	BackgroundSettings, DesignPanelBody, ButtonControlsHelper, ButtonEditHelper,
} from '~cartzillagb/components'
import { i18n, pluginAssetsURL } from 'cartzillagb'
import classnames from 'classnames'

addFilter( 'cartzillagb.hero-block.edit.inspector.style.before', 'czgb/hero-block', ( output, props ) => {
	const {
		setAttributes,  
	} = props

	const {
		backgroundType,
		backgroundColor,
		backgroundImageURL,
		background,
		enableContainer,
		enableTitle,
		enablesubTitle,
		enableForm,
		design,
		align = 'align-center',
		enableButton,
		enableCategory
	} = props.attributes

	return (
		<Fragment>
			<DesignPanelBody
				initialOpen={ true }
				selected={ design }
				options={ applyFilters( 'cartzillagb.hero-block.edit.layouts', [
					{
						label: __( 'Style - 1', i18n ), value: 'style-1', image: ImageDesignBasic,
					},
					{
						label: __( 'Style - 2', i18n ), value: 'style-2', image: ImageDesignPlain,
					},
				] ) }
				onChange={ design => setAttributes( { design } ) }
			>
			</DesignPanelBody>
			{ design === 'style-2' &&
				<PanelBody title={ __( 'Align', i18n ) } initialOpen={ false } >
					<SelectControl
						label={ __( 'Align' ) }
						values={ align }
						options={ [
							{ label: __('Align Center', 'cartzilla', i18n ), value: 'align-center' },
							{ label: __('Align Left', 'cartzilla', i18n ), value: 'align-left' },
							{ label: __('Align Right', 'cartzilla', i18n ), value: 'align-right' },
						] }
						onChange={ align => setAttributes( { align } ) }
					/>
				</PanelBody>
			}
			<PanelBody title={ __( 'General', i18n ) }>
				<ToggleControl
					label={ __( 'Enable Container ?', i18n ) }
					checked={ enableContainer }
					onChange={ enableContainer => setAttributes( { enableContainer } ) }
				/>
				<ToggleControl
					label={ __( 'Enable Title ?', i18n ) }
					checked={ enableTitle }
					onChange={ enableTitle => setAttributes( { enableTitle } ) }
				/>
				{ design === 'style-1' &&
					<ToggleControl
						label={ __( 'Enable Subtitle ?', i18n ) }
						checked={ enablesubTitle }
						onChange={ enablesubTitle => setAttributes( { enablesubTitle } ) }
					/>
				}

				{ design === 'style-2' &&
					<ToggleControl
						label={ __( 'Enable Catgeory List ?', i18n ) }
						checked={ enableCategory }
						onChange={ enableCategory => setAttributes( { enableCategory } ) }
					/>
				}
				<ToggleControl
					label={ __( 'Enable Button ?', i18n ) }
					checked={ enableButton }
					onChange={ enableButton => setAttributes( { enableButton } ) }
				/>
				<ToggleControl
					label={ __( 'Enable Form ?', i18n ) }
					checked={ enableForm }
					onChange={ enableForm => setAttributes( { enableForm } ) }
				/>
			</PanelBody>
			<PanelBody title={ __( 'Background Settings', i18n ) } initialOpen={ false }>
				<BackgroundSettings
					backgroundLabel={ __("Background Image", i18n ) }
					backgroundType={ backgroundType !== undefined ? backgroundType : '' }
					background={ background }
					backgroundColor={ backgroundColor }
					backgroundImageURL={ backgroundImageURL }
					onChangeBackgroundType={ backgroundType => setAttributes( { backgroundType } ) }
					onChangeBackground={ background => setAttributes( { background: ` ${ background }`, backgroundColor: '' } ) }
					onChangeBackgroundColor={ backgroundColor => setAttributes( { backgroundColor: backgroundColor.hex, background: '' } ) }
					onChangeBackgroundImage={ ( { url } ) => setAttributes( { backgroundImageURL: url } ) }
					onRemoveBackgroundImage={ () => {
						setAttributes( { backgroundImageURL: '' } )
					} }
					onRemoveBackground={ () => { setAttributes( { background: '', backgroundColor: '' } ) } }

				/>
			</PanelBody>
			<PanelBody title={ __( 'Button Settings', i18n ) }initialOpen={ false } >
				<ButtonControlsHelper
					attrNameTemplate="button1%s"
					setAttributes={ setAttributes }
					blockAttributes={ props.attributes }
				/>
			</PanelBody>
		</Fragment>
	)
} )

const edit = props => {
	const { 
		attributes, 
		setAttributes, 
		className,
	} = props 

	const {
		backgroundColor,
		backgroundImageURL,
		background,
		enableTitle,
		enablesubTitle,
		enableContainer,
		title,
		subTitle,
		enableForm,
		design,
		align,
		enableCategory,
		enableButton,
		subCategory1,
		subCategory2,
		subCategory3,
		subCategory4,
		subCategory5,
		subCategory6,
		subCategory7,
		subCategory8,
		subCategory9,
	} = attributes

	const mainClasses = classnames( [
		backgroundColor && backgroundColor,
		className,
	], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

	let defaultTitle = ''
	let defaultSubtitle = ''
	let defaultImg = ''

	if (design === 'style-1') {
		defaultTitle='<span class="font-weight-light">Over</span> 1,500 <span class="font-weight-light">curated</span> Design <span class="font-weight-light">resources</span>, Images, Graphic <span class="font-weight-light">&amp;</span> Website <span class="font-weight-light">templates</span>'
		defaultSubtitle='High quality items created by our global community',
		defaultImg=`${ pluginAssetsURL }img/hero-slider/img7.jpg`
	}
	if (design === 'style-2') {
		defaultTitle='<span class="font-weight-light">Multipurpose</span> Bootstrap 4<br>E-Commerce <span class="font-weight-light">Template</span>'
		defaultImg=`${ pluginAssetsURL }img/hero-slider/img10.jpg`
	}

	const styleAttr = {}

	if ( defaultImg || backgroundImageURL || backgroundColor ) {
		styleAttr.style = {
			backgroundImage: `url( ${ backgroundImageURL !== undefined ? backgroundImageURL : defaultImg } )`,
			//backgroundColor: backgroundColor !== undefined ? backgroundColor : ''
			backgroundColor: backgroundColor && backgroundColor, 
		}
	}


	const alignClass = classnames( [
		align ===  'align-right' && 'justify-content-right',
		align ===  'align-center' && 'justify-content-center',
		align ===  'align-left' && 'justify-content-left',
	] )

	const alignText = classnames( [
		align ===  'align-right' && 'text-right ml-auto',
		align ===  'align-center' && 'text-center',
		align ===  'align-left' && 'text-left',
	] )

	return (
		<div className={ mainClasses }>
			<section className={ `${ design === 'style-1' ? 'bg-position-center-top bg-no-repeat py-5' : 'bg-position-center bg-size-cover py-3 py-sm-5' } ${ background }` } { ...styleAttr }>
				<div className={ `${ design === 'style-1' ? 'pb-lg-5 mb-lg-3' : 'sub-category' }` }>
					<div className={ `${ enableContainer ? 'container' : '' } ${ design === 'style-1' ? 'py-lg-5 my-lg-5' : 'py-5' }` }>
						<div className={ `${ design === 'style-1' ? 'row mb-4 mb-sm-5' : 'row pt-md-5 pb-lg-5' } ${ design === 'style-2' && alignClass }` }>
							<div className={ `col-lg-7 col-md-9 ${ design === 'style-1' ? 'text-center text-sm-left' : `${ alignText } col-xl-6 py-xl-3` }` }>
								{ enableTitle &&
									<RichText
										tagName="h1"
										className={ `${ design === 'style-1' ? 'text-white line-height-base' : 'text-light pb-sm-3' }` } 
										value={ title !== undefined ? title : defaultTitle }
										onChange={ title => setAttributes( { title } ) }
										placeholder={ __( 'Title for This Block', i18n ) }
										keepPlaceholderOnFocus
									/>
								}
								{ ( design === 'style-1' && enablesubTitle ) &&
									<RichText
										tagName="h2"
										className="h5 text-white font-weight-light" 
										value={ subTitle !== undefined ? subTitle : defaultSubtitle }
										onChange={ subTitle => setAttributes( { subTitle  } ) }
										placeholder={ __( 'Subtitle for This Block', i18n ) }
										keepPlaceholderOnFocus
									/>
								}
								{ ( design === 'style-2' && enableCategory ) &&

								<div className="subcategory">
									<RichText
										tagName="span"
										className="d-inline-block h5 text-light font-weight-light mx-2 opacity-70" 
										value={ subCategory1 !== undefined ? subCategory1 : 'Single / Multi-vendor' }
										onChange={ subCategory1 => setAttributes( { subCategory1 } ) }
										placeholder={ __( 'subCategory1', i18n ) }
										keepPlaceholderOnFocus
									/>
									<RichText
										tagName="span"
										className="d-inline-block h3 text-light font-weight-light mx-2" 
										value={ subCategory2 !== undefined ? subCategory2 : 'Fashion' }
										onChange={ subCategory2 => setAttributes( { subCategory2 } ) }
										placeholder={ __( 'subCategory2', i18n ) }
										keepPlaceholderOnFocus
									/>
									<RichText
										tagName="span"
										className="d-inline-block h6 text-light font-weight-light mx-2 opacity-60" 
										value={ subCategory3 !== undefined ? subCategory3 : 'Electronics' }
										onChange={ subCategory3 => setAttributes( { subCategory3  } ) }
										placeholder={ __( 'subCategory3', i18n ) }
										keepPlaceholderOnFocus
									/>
									<RichText
										tagName="span"
										className="d-inline-block h3 text-light font-weight-light mx-2 opacity-90" 
										value={ subCategory4 !== undefined ? subCategory4 : 'Marketplace' }
										onChange={ subCategory4 => setAttributes( { subCategory4 } ) }
										placeholder={ __( 'subCategory4', i18n ) }
										keepPlaceholderOnFocus
									/>
									<RichText
										tagName="span"
										className="d-inline-block h5 text-light font-weight-light mx-2 opacity-50" 
										value={ subCategory5 !== undefined ? subCategory5 : 'Cart' }
										onChange={ subCategory5 => setAttributes( { subCategory5  } ) }
										placeholder={ __( 'subCategory5', i18n ) }
										keepPlaceholderOnFocus
									/>
									<RichText
										tagName="span"
										className="d-inline-block h4 text-light font-weight-light mx-2 opacity-80" 
										value={ subCategory6 !== undefined ? subCategory6 : 'Checkout' }
										onChange={ subCategory6 => setAttributes( { subCategory6  } ) }
										placeholder={ __( 'subCategory6', i18n ) }
										keepPlaceholderOnFocus
									/>
									<RichText
										tagName="span"
										className="d-inline-block font-size-lg text-light font-weight-light mx-2 opacity-60" 
										value={ subCategory7 !== undefined ? subCategory7 : 'Account' }
										onChange={ subCategory7 => setAttributes( { subCategory7  } ) }
										placeholder={ __( 'subCategory7', i18n ) }
										keepPlaceholderOnFocus
									/>
									<RichText
										tagName="span"
										className="d-inline-block h4 text-light font-weight-light mx-2 opacity-90" 
										value={ subCategory8 !== undefined ? subCategory8 : 'Dashboard' }
										onChange={ subCategory8 => setAttributes( { subCategory8  } ) }
										placeholder={ __( 'subCategory8', i18n ) }
										keepPlaceholderOnFocus
									/>
									<RichText
										tagName="span"
										className="d-inline-block h6 text-light font-weight-light mx-2 opacity-50" 
										value={ subCategory9 !== undefined ? subCategory9 : 'Grocery store' }
										onChange={ subCategory9 => setAttributes( { subCategory9 } ) }
										placeholder={ __( 'subCategory9', i18n ) }
										keepPlaceholderOnFocus
									/>
								</div>
								}
								{ enableButton &&
									<div className="py-4 py-sm-5">
										<ButtonEditHelper
											attrNameTemplate={ `button1%s` }
											setAttributes={ setAttributes }
											blockAttributes={ props.attributes }
										/>
									</div>
								}
							</div>
						</div>
						{ enableForm &&
							<div className={ `row pb-lg-5 mb-4 mb-sm-5 ${ design === 'style-2' && alignClass }`}>
								<div className={`col-lg-6 col-md-8 ${ alignText }`}>

								<InnerBlocks
									template={
										[ 
											[ 'czgb/hero-search-form', {
												keywords_placeholder_text: 'Start your search'
											} ]
										]
									}
									templateLock="all"
								/>
				
									
								</div>
							</div>
						}
					</div>
				</div>
			</section>
		</div>
	)
}

export default compose(
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )